import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// import './form_login.css';

function FormLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // não deixa a submissão recarregar a página

    try {

        const response = await fetch(`https://rvensino.com.br/get.php?action=login&email=${email}&password=${password}`
        );

        const data = await response.json();

        if (data.status === 0) {
          // Guarda nome e id no localStorage
          localStorage.setItem('userID', data.ID_usuario);
          localStorage.setItem('userName', data.nome);
        
          // Navega para a página principal com estado
          navigate('/', { state: { userID: data.ID_usuario, userName: data.nome, fromLogin: true } });
        }
        
        
        else {
            // Login falhou
            setErrorMessage('Login falhou. Cheque suas credenciais.');
        }
    } catch (error) {
        console.error('Erro ao logar: ', error);
        setErrorMessage('Um erro ocorreu. Tente novamente mais tarde.');
    }



    
};

  return (
    <form onSubmit={handleLogin}>
        <Link to="/login" className="no-link-style">
        <img src="https://rvensino.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className='login-logo' />
      </Link>
      <input type="text" placeholder="Email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input type="password" placeholder="Senha" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      <button className='button' type="submit"> Entrar </button>
      <Link to="/esqueciasenha" className='no-link-style'>
      <div className="link-cadastro">Esqueci a Senha</div>
      </Link>
      {/* <Link to="/cadastro" className='no-link-style'>
      <div className="link-cadastro">Realizar Cadastro</div>
      </Link> */}
    </form>
  );
}

export default FormLogin;